<template>
  <div
    :class="[
      $style.tournamentCard,
      $style[type],
      { [$style.tournamentsFinished]: isFinishedRace, [$style.tournamentComingSoon]: isComingSoon },
    ]"
    @click.prevent="$emit('cardClick')"
  >
    <div :class="$style.tournamentCardRight">
      <!-- /images/infopage/test_bonus_front.png -->
      <img :class="[$style.tournamentCardImageFront]" :src="imageFront.url" alt="promotionCard" />
      <!-- /images/infopage/test_bonus_back.png -->
      <img
        v-if="imageBack?.url"
        :class="$style.tournamentCardImageBack"
        :src="imageBack.url"
        alt=""
      />
    </div>
    <div :class="$style.tournamentCardLeft">
      <div :class="$style.tournamentCardLeftTopContent">
        <p :class="$style.tournamentCardOffer">
          {{ offer }}
        </p>
        <p v-if="title" :class="$style.tournamentCardTitle">{{ title }}</p>
        <TournamentStatus
          v-if="statusData && !$slots['before-timer'] && type === 'modal'"
          :class="$style.tournamentCardJoinedIcon"
          :status-data="statusData"
        />
        <template v-if="type !== 'modal'">
          <div v-if="!isEndedTimer" :class="$style.tournamentCardMiddleContent">
            <slot name="before-timer" />
            <BitTimer
              v-if="timerEndTime"
              :start-time="Date.now()"
              :is-background="false"
              :end-time="new Date(timerEndTime).getTime()"
              :title-days="components.timer.daysTitle"
              :title-hours="components.timer.hoursTitle"
              :title-minutes="components.timer.minutesTitle"
              :title-seconds="components.timer.secondsTitle"
              class="tournamentCardTimer"
            >
              {{ timerTitle }}:
            </BitTimer>
          </div>
          <div v-else :class="$style.tournamentCardMiddleContent">
            <slot name="before-timer" />
            <div class="eventCardTimerEnded">
              <img
                class="timerIconEnded"
                height="15"
                width="15"
                src="/images/common/raceCardTimerTime.svg?url_encode"
                alt="raceCardTimerTime"
              />
              {{ timerTitleEnded }}
            </div>
          </div>
        </template>
      </div>
    </div>
    <div v-if="type !== 'modal'" :class="$style.tournamentCardTopItems">
      <BitCardLabel :class="$style.tournamentCardLabel" :color-theme="ribbonColor">
        {{ ribbonTitle }}
      </BitCardLabel>
      <TournamentStatus
        v-if="statusData && !$slots['before-timer']"
        :class="$style.tournamentCardJoinedIcon"
        variant="tooltip"
        :status-data="statusData"
      />
    </div>
    <div v-if="providerLogo" :class="$style.tournamentCardProviderLogo">
      <img :src="providerLogo.url" alt="" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { BitTimer, BitCardLabel, type ButtonType } from '@bit/ui-kit';

import { useStoreComponents } from '~/stores/strapi/components';
import { type IStrapiImage } from '~/types/strapiImage';
import TournamentStatus from '../tournamentStatus/tournamentStatus.vue';
import type { TournamentStatusData } from '../types';
import type { ERaceStatus } from '~/types/races';

defineProps({
  title: {
    type: String,
    default: '',
  },
  type: {
    type: String as PropType<'default' | 'modal'>,
    default: 'default',
  },
  imageFront: {
    type: Object as PropType<IStrapiImage>,
    required: true,
  },
  imageBack: {
    type: Object as PropType<IStrapiImage | undefined>,
    default: undefined,
  },
  isEndedTimer: {
    type: Boolean,
    default: false,
  },
  timerTitleEnded: {
    type: String,
    default: '',
  },
  offer: {
    type: String,
    required: true,
  },
  mechanicsData: {
    type: Object as PropType<{ title: string; description: string } | null>,
    default: null,
  },
  minimumBetValue: {
    type: String as PropType<string | null>,
    default: null,
  },
  timerEndTime: {
    type: Date,
    default: undefined,
  },
  timerTitle: {
    type: String,
    default: '',
  },
  activeButtonTitle: {
    type: String,
    required: true,
  },
  activeButtonType: {
    type: String as PropType<ButtonType>,
    default: 'primary',
  },
  ribbonTitle: {
    type: String,
    default: '',
  },
  ribbonColor: {
    type: String,
    default: '',
  },
  activeButtonGtm: {
    type: String,
    default: null,
  },
  status: {
    type: String as PropType<ERaceStatus>,
    default: '',
  },
  statusData: {
    type: Object as PropType<TournamentStatusData | null | undefined>,
    default: null,
  },
  isFinishedRace: {
    type: Boolean,
    default: false,
  },
  isComingSoon: {
    type: Boolean,
    default: false,
  },
  providerLogo: {
    type: Object as PropType<IStrapiImage>,
    default: null,
  },
});
defineEmits<{
  (e: 'cardClick'): void;
  (e: 'buttonClick'): void;
}>();

const components = useStoreComponents();
</script>

<style lang="scss" module src="./tournamentCard.scss"></style>
